/**
 * Pure helpers for finding files of the same type as a template. Shared by the
 * create-file duplicate check (mixins/fileDuplicateMatch.js) and the
 * request-a-file warning on the tradie pages.
 */

/**
 * Sort a list of files most-recently-updated first.
 */
export function sortFilesByRecency(files) {
  const updatedTime = (f) =>
    new Date(f.updated_at || f.status_updated_at || f.created_at || 0).getTime()
  return files.slice().sort((a, b) => updatedTime(b) - updatedTime(a))
}

/**
 * Match a list of files against the chosen template, most-recent first.
 * Match on template id first; otherwise match by name — the template's
 * label exactly, or as a prefix (e.g. "Passport: my old one") so renamed
 * files of the same type are still caught.
 */
export function matchFilesForTemplate(files, template) {
  const norm = (value) =>
    (value == null ? '' : String(value)).trim().toLowerCase()
  const label = norm(template.label)

  const matchesName = (file) => {
    const name = norm(file.name)
    if (!label) return false
    if (name === label) return true
    if (name.startsWith(label)) {
      // Require a word boundary so "Passport" doesn't match "Passports".
      const next = name.charAt(label.length)
      return next === '' || /[^a-z0-9]/.test(next)
    }
    return false
  }

  const byTemplate = files.filter(
    (f) =>
      f.template_id != null && Number(f.template_id) === Number(template.id),
  )
  const matches = byTemplate.length ? byTemplate : files.filter(matchesName)

  return sortFilesByRecency(matches)
}
